import React, { Component } from 'react';
import { indexOf } from 'lodash';
// import Editor from 'react-draft-wysiwyg';
let Editor = () => null;

class NewEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ready: false,
    };
  }

  componentDidMount() {
    import('react-draft-wysiwyg').then(({ Editor: WSYSIGEditor }) => {
      Editor = WSYSIGEditor;
      this.setState({ ready: true });
    });
  }

  render() {
    if (!this.state.ready) {
      return null;
    }
    
    // https://github.com/advisories/GHSA-fq5x-7292-2p5r
    // https://github.com/jpuri/react-draft-wysiwyg/issues/1460
    const toolbar = {
      ...this.props.toolbar || {}
    };
    if (indexOf(toolbar.options, 'embedded') >= 0) {
      throw new Error('"embedded" button is not allowed.')
    }
    // just in case
    toolbar.embedded = {
      ...(toolbar.embedded || {}),
      embedCallback: (url) => { 
        try {
          if (['http:', 'https:'].includes(new URL(url).protocol)) {
            return url;
          }
          throw new Error('Unsupported URL detected!');
        } catch (e) {
          alert(e.message); 
        }
      },
    };


    return (<Editor {...this.props} toolbar={toolbar} />);
  }
}

export default NewEditor;
